<template>
  <div class="replyStyle">
    <el-form ref="commentForm" v-model="commentForm" class="comment-form" size="small">
      <el-form-item class="form-item">
        <textarea id="contentText" v-model="commentForm.content" class="textarea" show-word-limit
          placeholder="请输入评论内容，可@相关人员，最多可输入200字" @keyup="checkInputLimit" @input="handleInputChange"
          @keyup.delete="handleChangeDelete"></textarea>
        <p v-if="limitTip == true" class="limit-tip">
          最多输入200字，您已输入200字，本次输入字数已达上限！
        </p>
      </el-form-item>
      <div v-show="userListShowFlag" id="show" class="user-list">
        <div class="header">
          人员列表
        </div>
        <div class="cont">
          <div v-if="userList.length == 0" class="no-match">
            {{ messageTip }}
          </div>
          <div v-for="(item,index) in userList" :key="index" class="user-item"
            @click="checkUser(item.name,item.userID,item.userName)">
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
      <el-form-item class="form-item">
        <el-button type="primary" class="comment-btn" size="small" @click="saveComment()">
          发表评论
        </el-button>
      </el-form-item>
    </el-form>
    <ul class="comment-list">
      <li v-if="commentList.length == 0" style="text-align:center;color: var(--info-color);padding: 10px;">
        暂无评论数据...
      </li>
      <li v-for="(item,index) in commentList" :key="index">
        <div class="img-con">
          {{ tox }}
        </div>
        <div class="text-con">
          <p style="overflow:hidden;">
            <i class="el-icon-chat-dot-round"></i>
            {{ item.createUserName }}
            <el-button v-if="(item.createUserId === currentUserID)" type="danger" size="small"
              style="float:right;padding:4px 8px;" plain @click="recall(item.cmntId)">
              删除
            </el-button>
          </p>
          <p class="date">
            {{ item.createDate }}
          </p>
          <p class="desc" :title="item.content">
            {{ item.content }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import requestIssueMg from "@/CommonDP/service/question-service";
import { mapState } from "vuex";
export default {
  name: "CommentInfo",
  props: {
    isCAD: {
      type: Boolean
    }
  },
  data() {
    return {
      clearTimeSet: "",
      commentList: [], // 评论列表
      commentForm: {
        // 评论表单
        typeId: 2, // 评论类型
        content: "", // 评论内容
        relaId: "", // 关联ID
        prjId: "", // 项目id
        queryId: "", // 查询列表用到的关联ID
        userIds: [], // @人员id组合
        userList: [], // @人员组合
        fileIds: [] // 整合模型文件id
      },
      vcid: "",
      sourceModule: 0,
      messageTip: "",
      limitTip: false,
      userList: [], // 人员列表
      addUserText: "+ 添加人员", // 添加人员按钮
      userListShowFlag: false, // 是否显示人员下拉列表
      tempDeleteName: "",
      tox: "",
      currentUserID: ""
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    })
  },
  beforeDestroy() {
    // 页面关闭时清除定时器
    clearInterval(this.clearTimeSet);
  },
  mounted() {
    this.currentUserID = this.userInfo.userId;
    var str = this.userInfo.name;
    this.tox = str.charAt(0);
  },
  methods: {
    // 评论撤回
    recall(id) {
      this.$confirm("确定要撤回此评论吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          requestIssueMg.recallComment(id).then((res) => {
            if (res.result == "0") {
              this.$message.success("撤回成功");
              this.fetchData(this.commentForm.queryId, this.commentForm.prjId);
            }
          });
        })
        .catch((e) => {
          this.$message({
            type: "info",
            message: "已取消撤回"
          });
        });
    },
    showCommentInfo(sourceModule, prjId, typeId, relaId, queryId, vcid, fileIds) {
      // 调用评论模板是请从主页面传六个参数(来源页面,项目id,评论类型、发布评论用的关联ID、查询列表用的关联Id,vcid[没有请传空字符串])
      this.commentForm.prjId = prjId;
      this.commentForm.typeId = typeId;
      this.commentForm.relaId = relaId;
      this.commentForm.queryId = queryId;
      this.commentForm.fileIds = fileIds;
      this.vcid = vcid;
      this.sourceModule = sourceModule;
      this.fetchData(queryId, prjId);
      this.setTime(queryId, prjId);
    },
    // 设置定时器
    setTime(queryId, prjId) {
      this.clearTimeSet = setInterval(() => {
        this.fetchDataInterval(queryId, prjId);
      }, 8000);
    },
    // 评论列表
    fetchDataInterval(queryId, prjId) {
      requestIssueMg.getCommentList(queryId, prjId).then((res) => {
        if (res.result === "0") {
          this.commentList = res.data;
        }
      });
    },
    fetchData(queryId, prjId) {
      requestIssueMg.getCommentList(queryId, prjId).then((res) => {
        if (res.result === "0") {
          this.commentList = res.data;
          this.commentForm.content = "";
          this.commentForm.userIds = [];
          this.commentForm.userList = [];
        }
      });
    },
    handleInputChange() {
      const text = this.commentForm.content;
      if (text.length > 0 && text.lastIndexOf("@") === text.length - 1) {
        this.handleChange("");
      } else if (text.length > 0 && text.lastIndexOf("@") != -1 && text.lastIndexOf("@") < text.length - 1) {
        this.handleChange(text.substring(text.lastIndexOf("@") + 1));
      } else if (text.lastIndexOf("@") == -1) {
        this.userListShowFlag = false;
      }
    },
    handleChangeDelete() {
      const name = this.commentForm.content.substring(this.commentForm.content.lastIndexOf("@") + 1);
      if (this.userListShowFlag == true && name != "") {
        for (var i = 0; i < this.commentForm.userList.length; i++) {
          if (this.commentForm.userList[i].name == name) {
            this.tempDeleteName = name;
          }
        }
      } else if (this.userListShowFlag == true && name == "") {
        var tempArr = [];
        for (var i = 0; i < this.commentForm.userList.length; i++) {
          if (this.commentForm.userList[i].name != this.tempDeleteName) {
            tempArr.push(this.commentForm.userList[i]);
          }
        }
        this.commentForm.userList = tempArr;
      }
    },
    checkInputLimit() {
      const text = this.commentForm.content;
      if (text.length > 200) {
        this.limitTip = true;
      } else {
        this.limitTip = false;
      }
    },
    handleChange(addUserText) {
      this.userList = [];
      const name = addUserText;
      var reg = new RegExp(name);
      if (this.sourceModule == 1) {
        requestIssueMg.queryVCUser(this.vcid, name).then((res) => {
          if (res.result === "0") {
            this.userList = res.data;
            if (name.length == 0 && res.data.length == 0) {
              this.userListShowFlag = true;
              this.messageTip = "暂无人员";
              setTimeout(() => {
                this.userListShowFlag = false;
              }, 700);
            } else if (name.length > 0 && res.data.length == 0) {
              this.messageTip = "无匹配人员，请重新录入";
              this.userListShowFlag = false;
            } else {
              this.userListShowFlag = true;
              for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].name == name) {
                  var obj = {
                    userID: res.data[i].userID,
                    userName: res.data[i].userName,
                    name: res.data[i].name
                  };
                  this.commentForm.userList.push(obj);
                }
              }
            }
          }
        });
      } else if (this.sourceModule == 2) {
        // 来源于问题管理的点评问题评论
        requestIssueMg.queryVCUser(this.vcid, name).then((res) => {
          if (res.result === "0") {
            this.userList = res.data;
            if (name.length == 0 && res.data.length == 0) {
              this.userListShowFlag = true;
              this.messageTip = "暂无人员";
              setTimeout(() => {
                this.userListShowFlag = false;
              }, 700);
            } else if (name.length > 0 && res.data.length == 0) {
              this.messageTip = "无匹配人员，请重新录入";
              this.userListShowFlag = false;
            } else {
              this.userListShowFlag = true;
              for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].name == name) {
                  var obj = {
                    userID: res.data[i].userID,
                    userName: res.data[i].userName,
                    name: res.data[i].name
                  };
                  this.commentForm.userList.push(obj);
                }
              }
            }
          }
        });
      } else if (this.sourceModule == 3) {
        // 来源于图模审核的问题评论
        requestIssueMg.getUserInfoListByPrjId(this.commentForm.prjId).then((res) => {
          if (res.result === "0") {
            for (var i = 0; i < res.data.length; i++) {
              res.data[i].userID = res.data[i].userId;
            }
            for (var i = 0; i < res.data.length; i++) {
              var temp = res.data[i].name;
              if (temp.match(reg)) {
                this.userList.push(res.data[i]);
              }
            }
            if (name.length == 0 && this.userList.length == 0) {
              this.userListShowFlag = true;
              this.messageTip = "暂无人员";
              setTimeout(() => {
                this.userListShowFlag = false;
              }, 700);
            } else if (name.length > 0 && this.userList.length == 0) {
              this.messageTip = "无匹配人员，请重新录入";
              this.userListShowFlag = false;
            } else {
              this.userListShowFlag = true;
              for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].name == name) {
                  var obj = {
                    userID: res.data[i].userID,
                    userName: res.data[i].userName,
                    name: res.data[i].name
                  };
                  this.commentForm.userList.push(obj);
                }
              }
            }
          }
        });
      }
    },
    checkUser(name, userID, userName) {
      const text = this.commentForm.content.substring(0, this.commentForm.content.lastIndexOf("@"));
      this.commentForm.content = text + " @" + name + " ";
      var obj = { userID: userID, userName: userName, name: name };
      this.commentForm.userList.push(obj);
      this.userListShowFlag = false;
      document.getElementById("contentText").focus();
    },
    saveComment() {
      var tempNary = this.commentForm.userList;
      this.commentForm.userList = this.duplicate(this.commentForm.userList, "name");
      if (this.commentForm.content && !this.limitTip) {
        if (tempNary.length > this.commentForm.userList.length) {
          this.$confirm("评论内容中@人员重复，是否继续发表评论?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              const tempArr = [];
              for (var i = 0; i < this.commentForm.userList.length; i++) {
                if (this.commentForm.content.indexOf("@" + this.commentForm.userList[i].name) != -1) {
                  tempArr.push(this.commentForm.userList[i]);
                }
              }
              this.commentForm.userList = tempArr;
              for (var i = 0; i < this.commentForm.userList.length; i++) {
                this.commentForm.userIds.push(this.commentForm.userList[i].userID);
              }
              const params = {
                content: this.commentForm.content,
                prjId: this.commentForm.prjId,
                relaId: this.commentForm.relaId,
                typeId: this.commentForm.typeId,
                userIds: this.commentForm.userIds,
                fileIds: this.commentForm.fileIds
              };
              requestIssueMg.createComment(params).then((res) => {
                if (res.result === "0") {
                  this.$message.success("评论成功！");
                  this.fetchData(this.commentForm.queryId, this.commentForm.prjId);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消评论"
              });
            });
        } else {
          const tempArr = [];
          for (var i = 0; i < this.commentForm.userList.length; i++) {
            if (this.commentForm.content.indexOf("@" + this.commentForm.userList[i].name) != -1) {
              tempArr.push(this.commentForm.userList[i]);
            }
          }
          this.commentForm.userList = tempArr;
          for (var i = 0; i < this.commentForm.userList.length; i++) {
            this.commentForm.userIds.push(this.commentForm.userList[i].userID);
          }
          const params = {
            content: this.commentForm.content,
            prjId: this.commentForm.prjId,
            relaId: this.commentForm.relaId,
            typeId: this.commentForm.typeId,
            userIds: this.commentForm.userIds,
            fileIds: this.commentForm.fileIds
          };
          requestIssueMg.createComment(params).then((res) => {
            if (res.result === "0") {
              this.$message.success("评论成功！");
              this.fetchData(this.commentForm.queryId, this.commentForm.prjId);
            }
          });
        }
      } else {
        if (this.limitTip) {
          this.$message({
            message: "最多输入200字，您已输入200字，本次输入字数已达上限",
            type: "warning"
          });
        } else {
          this.$message({
            message: "输入评论内容",
            type: "warning"
          });
        }
      }
    },
    // 数组去重
    duplicate(arr, type) {
      if (arr.length == 0) {
        return arr;
      } else {
        if (type) {
          var obj = {};
          var newArr = arr.reduce((cur, next) => {
            obj[next.userID] ? "" : (obj[next.userID] = true && cur.push(next));
            return cur;
          }, []);
          return newArr;
        } else {
          return Array.from(new Set(arr));
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.replyStyle {
  width: 100%;
  height: 100%;
  padding: 8px 16px;
  overflow-y: auto;
  box-sizing: border-box;
}
.comment-form {
  position: relative;
  margin-top: 20px;
  .form-item {
    margin: 0 10px;
    margin-bottom: 10px;
    .comment-btn {
      float: right;
      background: #659fdc;
      font-size: 16px;
      padding: 10px 8px;
      margin-top: 10px;
    }
  }
}
.textarea {
  height: 110px;
  width: 95%;
  border: 1px solid #ccc;
  padding: 10px 2%;
  border-radius: 5px;
}
.limit-tip {
  color: #f00;
  line-height: 12px;
  font-size: 12px;
  padding-bottom: 6px;
}
.comment-list {
  padding: 0px 0;
  margin: 3px;
  border-top: 1px solid #ddd;
  li {
    width: 100%;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
    overflow: hidden;
    display: flex;
    flex-direction: row;

    .img-con {
      // float: left;
      width: 38px;
      height: 38px;
      margin-top: 4px;
      border: 1px solid #4777e7;
      background: #4777e7;
      color: #fff;
      border-radius: 50%;
      line-height: 38px;
      text-align: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text-con {
      width: calc(100% - 40px);
      // float: left;
      padding-left: 4px;
      p {
        padding-top: 10px;
      }
      .date {
        color: var(--info-color);
        padding-top: 5px;
      }
      .desc {
        // width: 230px;
        // text-overflow: -o-ellipsis-lastline;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-line-clamp: 5;
        // -webkit-box-orient: vertical;
        word-wrap: break-word;
      }
    }
  }
}
.user-container {
  float: left;
  width: calc(100% - 2px);
  border: 1px solid #ddd;
  ul {
    float: left;
    margin: 6px;
    li {
      float: left;
      color: #1d8bf0;
      border: 1px solid #1d8bf0;
      border-radius: 5px;
      height: 28px;
      line-height: 28px;
      margin: 6px;
      padding: 0 5px;
      .el-icon-close {
        margin-left: 5px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
  .add-con {
    float: left;
    position: relative;
    margin: 8px 6px 6px 6px;
    .add-input {
      width: 70px;
      padding: 6px 8px;
      vertical-align: middle;
      border: 1px solid #1d8bf0;
      color: #1d8bf0;
      border-radius: 5px;
    }
  }
}
.user-list {
  position: absolute;
  top: 70%;
  left: 10px;
  z-index: 9999;
  width: 150px;
  background: #fff;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  color: #333;
  .header {
    height: 30px;
    line-height: 30px;
    background: #97bacd;
    color: #000;
    text-align: center;
  }
  .cont {
    min-height: 200px;
    max-height: 200px;
    overflow-y: scroll;
  }
  .space-icon {
    display: block;
    position: absolute;
  }
  .no-match {
    text-align: center;
    color: #f00;
    line-height: 20px;
    padding: 0px 15px;
  }
  .user-item {
    border-bottom: 1px dotted #bbb;
    font-size: 12px;
    cursor: pointer;
    padding: 0 6px;
    &:hover {
      background: #91c2f0;
    }
    p {
      line-height: 30px;
    }
  }
}
</style>

